<template>
<!-- Recommended Banner -->
    <section class="section-blk recommended-blk style1-blk">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">

                    <div class="row justify-content-center">
                        <div class="col-lg-12">
                            <div class="recommended-tabs-blk">
                                <ul class="nav tabs-style gap-3" data-bs-tabs="tabs">
										<li>
											<a class="active" aria-current="true" data-bs-toggle="tab" href="#hotels">
												<span>
													<img src="../../../assets/img/icons/trip-icon-01.svg" alt="Dreamstrip Recommended">
												</span>
												hotel
											</a>
										</li>
										<li>
											<a data-bs-toggle="tab" href="#restaurants">
												<span>
													<img src="../../../assets/img/icons/trip-icon-02.svg" alt="Dreamstrip Recommended">
												</span>
												Restaurants
											</a>
										</li>
										<li>
											<a data-bs-toggle="tab" href="#shops">
												<span>
													<img src="../../../assets/img/icons/trip-icon-03.svg" alt="Dreamstrip Recommended">
												</span>
												shops
											</a>
										</li>
										<li>
											<a data-bs-toggle="tab" href="#business">
												<span>
													<img src="../../../assets/img/icons/trip-icon-04.svg" alt="Dreamstrip Recommended">
												</span>
												business
											</a>
										</li>
										<li>
											<a data-bs-toggle="tab" href="#lifestyle">
												<span>
													<img src="../../../assets/img/icons/trip-icon-05.svg" alt="Dreamstrip Recommended">
												</span>
												lifestyle
											</a>
										</li>
									</ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-body tab-content">
                        <div class="tab-pane active">
                            <recommendslide />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- /Recommended Banner -->

    <!-- Offer Banner -->
 
<!-- /Offer Banner -->
</template>

<script>

</script>